import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * Services Files
 */
import { PrintLabelService } from "../../../services/search/printLabel/print-label.service";



@Component({
  selector: 'app-event-print-label-with-mobile-no',
  templateUrl: './event-print-label-with-mobile-no.component.html',
  styleUrls: ['./event-print-label-with-mobile-no.component.less']
})
export class EventPrintLabelWithMobileNoComponent implements OnInit {

  @Input('eventId') id: any;
  @Output() outToParent = new EventEmitter<string>()

  public printLabel: any = []

  constructor(private PrintLabelService: PrintLabelService) { }

  ngOnInit() {
    let value = this.id
    if (value.reqParams == "post") {
      this.getEventPrintLabelViaPost(value.value)
    } else {
      this.getEventPrintLabel(this.id)
    }

  }

  async getEventPrintLabel(query) {
    let label = await this.PrintLabelService.getEventPrintLabel(query)
    this.printLabel = label.data
    console.log(this.printLabel)
    await this.notificationToParent()
  }

  async getEventPrintLabelViaPost(query) {

    let split = query.split("\n")
    console.log(split)
    let data = {
      "partners_list":split
    }
    console.log(data)
    let label = await this.PrintLabelService.postEventPrintLabel(data)
    this.printLabel = label.data
    console.log(this.printLabel)
    await this.notificationToParent()
  }

  async notificationToParent() {
    this.outToParent.emit("emit")
  }

}
